module.exports = __webpack_public_path__ + "static/media/medicare-download.3a7fa46d.jpg";